"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthorizationHeader = exports.getBearer = exports.removeToken = exports.setToken = exports.getToken = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var cookieKey = "WARDEN_SSO_AUTHORIZATION";
function getToken() {
    return js_cookie_1.default.get(cookieKey);
}
exports.getToken = getToken;
function getAuthorizationHeader(token) {
    if (token === void 0) { token = getToken(); }
    return {
        Authorization: getBearer(token)
    };
}
exports.getAuthorizationHeader = getAuthorizationHeader;
function getBearer(token) {
    if (token === void 0) { token = getToken(); }
    return "Bearer " + token;
}
exports.getBearer = getBearer;
function setToken(token) {
    js_cookie_1.default.set(cookieKey, token, { path: "/" });
}
exports.setToken = setToken;
function removeToken() {
    js_cookie_1.default.remove(cookieKey, { path: "/" });
}
exports.removeToken = removeToken;
